<!--
  Los logos llegan como JPEG sin transparencia, con el negro quemado dentro de
  la imagen: sobre negro el cuadrado desaparece, sobre cualquier otro fondo
  vuelven los recuadros que el cliente leyó como desorden (ABC-374). El fondo
  negro es una restricción del material, no una decisión estética — cuando
  lleguen los PNG con transparencia se puede revisar.
-->
@if (items.length) {
  <section
    data-test="partners"
    [attr.aria-labelledby]="titleId"
    class="bg-artstgo-black py-10 sm:py-14"
  >
    <!-- El título existe sólo para lectores de pantalla: la tira se lee sola. -->
    <h2 [id]="titleId" class="sr-only">Partners de Art Santiago</h2>

    <!--
      La pista lleva la tira dos veces y se desplaza hasta -50%: al llegar, el
      comienzo de la segunda copia está exactamente donde estaba el de la
      primera, así que el salto de vuelta a 0 no se ve.
      La segunda copia es decorativa — `aria-hidden` y sin foco — para que un
      lector de pantalla y el tabulador recorran cada sponsor una sola vez.
    -->
    <div data-test="partners-viewport" class="partners__viewport">
      <div
        data-test="partners-track"
        class="partners__track"
        [style.--partners-duration]="duration"
      >
        @for (item of items; track item.url) {
          <ng-container
            *ngTemplateOutlet="logo; context: { $implicit: item, clone: false }"
          />
        }
        @for (item of items; track item.url) {
          <ng-container
            *ngTemplateOutlet="logo; context: { $implicit: item, clone: true }"
          />
        }
      </div>
    </div>
  </section>
}

<ng-template #logo let-item let-clone="clone">
  <div
    class="partners__item flex shrink-0 items-center gap-x-6 sm:gap-x-10"
    [class.partners__item--clone]="clone"
    [attr.aria-hidden]="clone ? 'true' : null"
  >
    @if (item.groupLabel) {
      <h3
        class="rotate-180 whitespace-nowrap font-display text-[0.625rem] font-semibold uppercase tracking-[0.2em] text-neutral-400 [writing-mode:vertical-rl]"
      >
        {{ item.groupLabel }}
      </h3>
    }
    @if (item.link) {
      <a
        data-sponsor-link
        [href]="item.link"
        target="_blank"
        rel="noopener noreferrer"
        [attr.tabindex]="clone ? -1 : null"
        [attr.aria-label]="'Visitar el sitio de ' + item.host"
        class="block rounded opacity-80 transition-opacity duration-200 hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary motion-reduce:transition-none"
      >
        <img
          [src]="item.url"
          alt=""
          loading="lazy"
          [class]="item.heightClass + ' w-auto object-contain'"
        />
      </a>
    } @else {
      <img
        [src]="item.url"
        alt=""
        loading="lazy"
        [class]="item.heightClass + ' w-auto object-contain opacity-80'"
      />
    }
  </div>
</ng-template>
